module.exports = __webpack_public_path__ + "static/media/info_icon.3f8db2c9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Downloads/components/Wallet/info_icon.svg
// module id = 953
// module chunks = 0